module.exports = __webpack_public_path__ + "img/right-arrow.d5afc27e.svg";